module.exports = __webpack_public_path__ + "media/images/icons/repost_white-91fc5463e4a174f339c2eb17fb5a8083.svg";